import { TextField } from '@mui/material';

interface RedirectUriFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function RedirectUriField({
  value,
  error,
  setValue,
}: RedirectUriFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Redirect URI'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default RedirectUriField;

